<template>
  <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right">
    <transition-group name="breadcrumb">
      <template v-for="(item,index) in levelList">
        <el-breadcrumb-item :key="item.path" v-if="item.meta.title">
          <router-link v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect" :to="item.path">{{item.meta.title}}</router-link>
          <router-link v-else :to="rootBack(item)">{{item.meta.title}}</router-link>
          <!-- <router-link v-else :to="item.redirect||item.path">{{item.meta.title}}</router-link> -->
          <!-- <span v-else>{{item.meta.title}}</span> -->
        </el-breadcrumb-item>
      </template>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import storage from '@/util/storage'
export default {
  name: 'BreadCrumb',
  created () {
    this.getBreadcrumb()
  },
  data () {
    return {
      levelList: null
    }
  },
  watch: {
    $route () {
      this.getBreadcrumb()
    }
  },
  methods: {
    rootBack(menuItem) {
      const arr = storage.get('navMenu') || []
      const filterArr = arr.filter((item) => {
        return item.powerUrl === menuItem.path
      })
      if (filterArr.length) {
        if (filterArr[0].children.length) {
          return filterArr[0].children[0].powerUrl
        }
      }
      return menuItem.path
    },
    getBreadcrumb () {
      const matched = this.$route.matched.filter(item => item.name)
      if (this.$route.path === '/purchase/purchaseManage/createContract') {
        matched[matched.length - 1].meta.title = this.$route.query.type
      }
      this.levelList = matched
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    // height: 48px;
    // line-height: 48px;
    margin-left: 10px;
    margin-bottom: 10px;
    .no-redirect {
      color: #276CFF;
      cursor: text;
    }
  }
  ::v-deep .el-breadcrumb__inner a{
    font-weight: normal !important;
  }
  .app-breadcrumb.el-breadcrumb .no-redirect{
    font-weight: bold !important;
  }
</style>
